import { Button,Box,CircularProgress,styled } from '@material-ui/core'
import './AmsButton.css'

import { getMobileOperatingSystem } from '../../utils/helpers'
import { useEffect } from 'react'

export type ButtonProps = {
    label: string,
    handleClick: any,
    styles?: any,
    loading?: any,
    disable?: any,
}


const AmsButton = (props: any) => {
    const {
        label,
        variant,
        type,
        styles,
        nextScreen,
        icon = '',
        labelExtnd = '',
        loading = false,
        identifier,
        id,
        name,
        iconImg,
        iconImgWidth,
        className,
        isRound = false,
        ...rest
    } = props?.attributes
    const {handleClick,disable} = props;

    // const handleOnclick = (event:any) => {
    //     handleClick(event)
    // }


        

 
    return (
        <Box textAlign="center" sx={props.styles ? { ...props.styles } : {}} className={`buttonBlock ${isRound ? "roundButton" : ""}`}>
            <Button
                className={disable ? 'btnDisable' : className}
                id={id}
                name={name}
                onClick={handleClick}
                disabled={disable}
                sx={{
                    ...styles,
                    '&:hover': {
                        borderWidth: 2,
                    },
                }}
                endIcon={loading ? <CircularProgress size={20} /> : null}
                {...rest}
            >
                {label}{' '}
                {/* {icon && (
                    <Box component="span" mx={1} maxHeight={41}>
                        <CustomIcon iconName={icon} />
                    </Box>
                )} */}
                {iconImg && (
                    <Box
                        component="span"
                        mx={1}
                        maxHeight={41}
                        pt={'8px'}
                        pr={'8px'}
                        display="flex"
                    >
                        <img src={iconImg} height={18} width={iconImgWidth ? iconImgWidth :18} className='buttonIcon' />
                    </Box>
                )}{' '}
                {labelExtnd}
            </Button>
        </Box>
    )
}

export default AmsButton